import axios from "axios";

// 获取数据
export const getInfo = params => {
  return axios
    .get(
      `http://user.ihuyi.com/wxeditor/api/${params.url}page=${
        params.page
      }&tag=${params.tag}`
    )
    .then(res => {
      if (res.status === 200 && res.data.code === 0) {
        return res.data;
      }
    })
    .catch(e => {
      console.log(e);
    });
};



// WEBPACK FOOTER //
// ./src/result.js